// What a mail template says, read the way the mail service will read it.
//
// A template is Handlebars HTML in Firebase (`handlebar`), filled at send time with the variables a
// campaign send provides (the backend's CAMPAIGN_EMAIL_VARIABLES, returned with every template
// read). These checks are facts about the text, not opinions: a {{name}} nothing fills prints
// blank in every inbox, and an image with a relative src points at a file on someone's computer.

const HELPERS = new Set(['else', 'this']);

/** The variables a template refers to — {{x}} and {{{x}}}, not block helpers ({{#if}}, {{/if}}). */
export const variablesIn = (text) => {
  const out = new Set();
  for (const [, sigil, word, arg] of String(text || '').matchAll(/\{\{\{?\s*([#/^>!]?)\s*([\w.]+)(?:\s+([\w.]+))?/g)) {
    // {{#if firstName}} reads firstName; the helper's own name is not a variable.
    if (sigil === '#' || sigil === '^') { if (arg) out.add(arg); continue; }
    if (sigil) continue;
    if (!HELPERS.has(word)) out.add(word);
  }
  return [...out];
};

const fold = (s) => String(s).toLowerCase().replace(/[^a-z0-9]/g, '');

export const checkMailTemplate = ({ subject, html }, variables) => {
  const known = new Map((variables || []).map((v) => [v.key, v]));
  const byFold = new Map((variables || []).map((v) => [fold(v.key), v.key]));
  const used = [...new Set([...variablesIn(subject), ...variablesIn(html)])];
  const unknown = used.filter((k) => !known.has(k)).map((key) => ({ key, suggestion: byFold.get(fold(key)) || null }));
  const localImages = [...new Set([...String(html || '').matchAll(/<img\b[^>]*\bsrc\s*=\s*["']([^"']+)["']/gi)]
    .map((m) => m[1]).filter((src) => !/^(https?:|data:|cid:|\{\{)/i.test(src.trim())))];
  return { used, known: used.filter((k) => known.has(k)), unknown, localImages };
};

/** Every {{key}} → its value; one with no value is blank, exactly as the mail service renders it. */
export const fillSample = (text, sample) =>
  String(text || '').replace(/\{\{\{?\s*([\w.]+)\s*\}?\}\}/g, (all, key) => (HELPERS.has(key) ? all : String(sample?.[key] ?? '')));

/** Rename one variable throughout ({{first_name}} → {{firstName}}), keeping {{{ }}} where it was. */
export const renameVariable = (text, from, to) =>
  String(text || '').replace(new RegExp(`(\\{\\{\\{?\\s*)${from.replace(/[.]/g, '\\.')}(\\s*\\}?\\}\\})`, 'g'), `$1${to}$2`);

/** A stand-in recipient for the preview, named as such so nobody mistakes it for a real one. */
export const SAMPLE_RECIPIENT = {
  firstName: 'Amina',
  name: 'Amina Nakato',
  email: 'amina@example.com',
  unsubscribe_url: '#unsubscribe',
};
